import ReaxlNextLink from '@/components/ReaxlNextLink';

export default {
    // This is used to allow all reaxl/Links to use NextJS' link component
    // TODO fix issue with onPageEnter and add this back in.
    linkRenderer: ReaxlNextLink,
};
